/**  Типы договоров. */
export enum CatalogsTypes {
  /**Папка элементов. */
  Folder = 0,

  /**Операция. */
  Operation = 1,

  /** Операция с предзаполенеными полями.*/
  ExtOperation = 2
}
